import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import $ from 'jquery';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'app-promotion-menu-bar',
  templateUrl: './promotion-menu-bar.component.html',
  styleUrls: ['./promotion-menu-bar.component.scss']
})
export class PromotionMenuBarComponent implements OnInit, OnDestroy {

  private _firstLandingState: string;
  private _landingPageState: string;
  public language: string;

  private isMobileDisplayMenu = false;
  private isfirstSection = false;
  private isLogin = false;
  private isShowListLanguage = false;
  private canChangePassword = true;
  private showApprovalList = false;
  private isMobile = false;
  private appConfigSubscription: Subscription;

  public logoPath: string;
  public logoDefaultPath: string;

  @Input() theme = '';

  @Input() notFoundPage = false;

  @Input('firstLandingState')
  set firstLandingState(firstLandingState: string) {
    this._firstLandingState = firstLandingState ? firstLandingState : '';
  }

  @Input('landingPageState')
  set landingPageState(landingPageState: string) {
    this._landingPageState = landingPageState ? landingPageState : '';
    this.isfirstSection = this._landingPageState === this._firstLandingState;
  }

  @Output('onMobileToggleMenuBar') mobileToggleMenuBar = new EventEmitter(); // tslint:disable-line

  constructor(
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    public dialog: MdDialog,
    public router: Router
  ) { }

  ngOnInit() {
    this.language = this.appConfigService.getLanguage();
    this.isMobile = this.utilitiesService.isMobile();

    this.appConfigSubscription = this.appConfigService.getLanguageObs().subscribe((lang) => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        this.handleBlurMenuBar();
      }
    });

    this.setLogoPath();
  }

  ngOnDestroy() {
    this.utilitiesService.unlockBody();
    this.appConfigSubscription && this.appConfigSubscription.unsubscribe();
  }

  getLang() {
    return this.appConfigService.getLanguage();
  }

  handleToggleMenuBar(e: Event) {
    this.isMobileDisplayMenu = !this.isMobileDisplayMenu;
    this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });

    if (this.isMobileDisplayMenu) {
      $('html').addClass('-open-sidemenu');
      this.utilitiesService.lockBody();
    } else {
      $('html').removeClass('-open-sidemenu');
    }
  }

  handleBlurMenuBar() {
    this.isMobileDisplayMenu = false;
    this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
    $('html').removeClass('-open-sidemenu');
    this.utilitiesService.unlockBody();
  }

  handleShowListLanguage(e: Event) {
    this.isShowListLanguage = !this.isShowListLanguage;
  }

  handleChangeLanguage(languageCode: string) {
    this.appConfigService.setLanguage(languageCode);
    this.isShowListLanguage = false;
    this.language = languageCode;
  }

  setLogoPath() {
    const { ActLogoPath } = this.appConfigService.getActLogoPath();
    const { ActDefaultLogoPath } = this.appConfigService.getActDefaultLogoPath();
    this.logoPath = ActLogoPath;
    this.logoDefaultPath = ActDefaultLogoPath;
  }
}




// WEBPACK FOOTER //
// ./src/app/components/promotion/promotion-menu-bar/promotion-menu-bar.component.ts